import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { BiSearch, BiSolidEdit, BiSolidTrash } from "react-icons/bi";
import { FaUserTag } from "react-icons/fa";
import { MdOutlineDisabledVisible } from "react-icons/md";
import { useSelector } from "react-redux";
import { Button, Table } from "reactstrap";
import { deleteDocument, saveData } from "../../firebase/utility";
import General_Pagination from "../General_Pagination";
import GeneralButton from "../button/GeneralButton";
import NotFoundDataUI from "../cards/NotFoundDataUI";
import FormInput from "../formInput/FormInput";
import AddNewUserModal from "../modals/AddNewUserModal";
import AssignCustomersModal from "../modals/AssignCustomersModal";
import DeleteModal from "../modals/DeleteModal";
import UpdateUserModal from "../modals/UpdateUserModal";
const SettingsTable = () => {
  const { users, user } = useSelector((state) => state.auth);
  const [search, setSearch] = useState("");
  const [filterUsers, setFilterUsers] = useState([]);

  // CREATE MODAL
  const [createUserModal, setCreateUserModal] = useState(false);
  const toggleCreateUserModal = () => setCreateUserModal(!createUserModal);

  // DELETE MODAL
  const [deleteUserModal, setDeleteUserModal] = useState(false);
  const toggleDeleteUserModal = () => setDeleteUserModal(!deleteUserModal);

  // DELETE MODAL
  const [updateUserModal, setUpdateUserModal] = useState(false);
  const toggleUpdateUserModal = () => setUpdateUserModal(!updateUserModal);

  // ASSIGN CUSTOMERS MODAL
  const [assignCustomersModal, setAssignCustomersModal] = useState(false);
  const toggleAssignCustomersModal = () => setAssignCustomersModal(!assignCustomersModal);


  const [isUpdate, setIsUpdate] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  useEffect(() => {
    let result = users ?? [];
    const currentUserRole = user?.role?.toLowerCase();
    if (currentUserRole === 'super-admin') {
      result = result.filter((u) => u?._id !== user?._id && u?.email !== user?.email);
    } else if (currentUserRole === 'admin') {
      result = result.filter((u) => u?.role?.toLowerCase() === 'supervisor');
    }
    if (search.trim()) {
      result = result.filter(
        (i) => i && i?.username?.toLowerCase().includes(search.toLowerCase())
      );
    }

    setFilterUsers(result);
  }, [search, users, user]);

  return (
    <>
      <AddNewUserModal
        toggle={toggleCreateUserModal}
        modal={createUserModal}
        isUpdate={isUpdate}
      />
      <UpdateUserModal
        toggle={toggleUpdateUserModal}
        modal={updateUserModal}
        isUpdate={isUpdate}
      />
      <AssignCustomersModal
        toggle={toggleAssignCustomersModal}
        modal={assignCustomersModal}
        user={isUpdate}
      />
      <DeleteModal toggle={toggleDeleteUserModal} modal={deleteUserModal} />

      <div className="d-flex justify-content-between align-items-center mb-4 search-input-wrapper">
        <div style={{ width: "350px" }}>
          <FormInput
            type={"text"}
            placeholder={"Search by username..."}
            className={`border-0 shadow-none`}
            size={"large"}
            icon={<BiSearch size={"20"} style={{ color: "#64748b" }} />}
            value={search}
            handleChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </div>
        <div>
          <GeneralButton
            title={"Create New User"}
            className={"create-user-btn text-white shadow-sm px-4"}
            handleClick={toggleCreateUserModal}
          />
        </div>
      </div>

      {filterUsers.length > 0 ? (
        <div>
          <Table
            responsive
            hover
            bordered
            className="mb-0"
            style={{
              fontSize: "15px",
              overflow: "hidden",
              border: "1px solid #e2e8f0"
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#00509d", color: "white" }}>
                <th className="text-center" style={{ borderBottom: "none" }}>Username</th>
                <th className="text-center" style={{ borderBottom: "none" }}>User Email</th>
                <th className="text-center" style={{ borderBottom: "none" }}>Role</th>
                <th className="text-center" style={{ borderBottom: "none" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {filterUsers.slice(startIndex, endIndex).map((row, index) => (
                <tr
                  key={index}
                  className="align-middle"
                  style={{
                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc",
                    borderBottom: "1px solid #f1f5f9"
                  }}
                >
                  <td className="text-center fw-bold">
                    <span>{row.username}</span>
                  </td>
                  <td className="text-center text-muted">{row.email}</td>
                  <td className="text-center">
                    <span className={`user-badge ${row.role === 'Admin' ? 'bg-primary-soft' : 'bg-secondary-soft'}`}>
                      {row.role}
                    </span>
                  </td>
                  <td className="text-center">
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      <Button
                        color="link"
                        className="p-1 border-0"
                        onClick={() => {
                          setIsUpdate(row);
                          toggleUpdateUserModal();
                        }}
                      >
                        <BiSolidEdit className="text-primary" size={16} />
                      </Button>
                      <Button
                        color="link"
                        className="p-1 border-0"
                        title="Assign Customers"
                        onClick={() => {
                          setIsUpdate(row);
                          toggleAssignCustomersModal();
                        }}
                      >
                        <FaUserTag className="text-info" size={16} />
                      </Button>
                      <Button
                        color="link"
                        className="p-1 border-0"
                        onClick={() => {
                          deleteDocument("Users", row?._id, "_id").then(
                            (res) => {
                              if (res) {
                                toast.success("User Deleted Successfully");
                              }
                            }
                          );
                        }}
                      >
                        <BiSolidTrash className="text-danger" size={16} />
                      </Button>

                      {row?.profile_status === "disabled" ? (
                        <Button
                          color="success"
                          size="sm"
                          className="px-2 py-1 border-0 rounded-pill"
                          style={{ fontSize: '11px', fontWeight: '600' }}
                          onClick={() => {
                            saveData("Users", row?._id, {
                              profile_status: "Enabled",
                            }).then((res) => {
                              if (res) {
                                toast.success("User Enabled Successfully");
                              }
                            });
                          }}
                        >
                          <MdOutlineDisabledVisible className="me-1" />{" "}
                          Enable
                        </Button>
                      ) : (
                        <Button
                          color="danger"
                          size="sm"
                          className="px-2 py-1 border-0 rounded-pill"
                          style={{ fontSize: '11px', fontWeight: '600' }}
                          onClick={() => {
                            saveData("Users", row?._id, {
                              profile_status: "disabled",
                            }).then((res) => {
                              if (res) {
                                toast.success("User Disabled Successfully");
                              }
                            });
                          }}
                        >
                          <MdOutlineDisabledVisible className="me-1" />{" "}
                          Disable
                        </Button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="mt-4">
            <General_Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              arr={filterUsers}
              itemsPerPage={itemsPerPage}
              pagename={"user"}
            />
          </div>
        </div>

      ) : (
        <NotFoundDataUI message="No users found" />
      )}
    </>
  );
};

export default SettingsTable;
